import React from 'react';

// tslint:disable max-line-length
const CShareTranscriptMunch: React.FC = () => (
  <>
    <h5>Postscript</h5>
    <p>Hey. So, there are people who believe that the more you give away, the richer you are.  Are you one of them?  You’ve given these things without taking them. You’ve taken time, and I know someone is going to appreciate that. Yeh. I think they’re gonna like it.</p>
  </>
);

export {
  CShareTranscriptMunch,
};
